/// <reference path="../../apps/typings/customTds.d.ts" />

import { AppUtils } from '../../shared/utils/index';

 
export namespace Url {
	export enum ParamsMultivalHandling {
		SINGLE, CSV, ARRAY
	}

	export function getParamsAsSingle(queryString: string): { [key: string]: string } {
		return AppUtils.Url.getParamsAsMap(queryString, ParamsMultivalHandling.SINGLE) as { [key: string]: string };
	}

	export function getParamsAsCSV(queryString: string): { [key: string]: string } {
		return AppUtils.Url.getParamsAsMap(queryString, ParamsMultivalHandling.CSV) as { [key: string]: string };
	}

	export function getParamsAsMap(queryString: string, multiValHandling = ParamsMultivalHandling.ARRAY): { [key: string]: string | string[] } {
		const params: { [key: string]: string | string[] } = {};
		const url = new URL(queryString.startsWith("?") ? queryString : `?${queryString}`, window.location.href);
		url.searchParams.forEach((value, key) => {
			if (params[key] && ParamsMultivalHandling.SINGLE !== multiValHandling) {
				if (ParamsMultivalHandling.CSV === multiValHandling) {
					params[key] += `,${value}`;
				} else {
					if (!Array.isArray(params[key])) {
						const v = params[key] as string;
						params[key] = [];
						(params[key] as string[]).push(v);
					}
					(params[key] as string[]).push(value);
				}
			} else {
				params[key] = value;
			}
		});
		return params;
	}

	/**
	 * Concatenates two path fragments correcting slashes
	 */
	export function combine(base: string, path: string): string {
		if (!path) {
			return base;
		}
		if (!base) {
			return path;
		}
		let result = `${base}`;
		if ("/" === result.charAt(result.length - 1)) {
			result = result.substring(0, result.length - 1);
		}
		if (path.charAt(0) !== "/") {
			result += "/";
		}
		result += path;
		return result;
	}

	export function updateUrlParameter(params: { [key: string]: any }, uri: string): string {
		return T.Utils.Helper.updateUrlParameter(params, uri);
	}

	/* istanbul ignore next: wrapper function */
	export function getUrlParameter(paramName: string, uri?: string): string {
		return T.Utils.Helper.getUrlParameter(paramName, uri);
	}

	/* istanbul ignore next: wrapper function */
	export function getUrlPathPart(part: number, uri?: string): string {
		return T.Utils.Helper.getUrlPathPart(part, uri);
	}


	export function downloadFileWithFallback(url: string): void {
		if ('download' in document.createElement('a')) {
			const $hiddenDownloadLink = $('<a>')
				.attr('href', url)
				.css('display', 'none');

			if (AppUtils.Helper.isAppleDevice() || AppUtils.Helper.isSafari()) {
				$hiddenDownloadLink.attr('target', '_blank');
			} else {
				$hiddenDownloadLink.attr('download', '');
			}

			$('body').append($hiddenDownloadLink);
			$hiddenDownloadLink[0].click();
			$hiddenDownloadLink.remove();
		} else {
			window.open(url, '_blank');
		}
	}

	export function mergeQueryParams(baseUrl: string, queryString?: string): string {
		const parsed = new URL(baseUrl, window.location.origin);

		if (queryString) {
			const newParams = new URLSearchParams(queryString);
			for (const key of newParams.keys()) {
				const value = newParams.get(key);
				if (value !== null) {
					parsed.searchParams.set(key, value);
				}
			}
		}

		const search = parsed.searchParams.toString();
		return search ? `${parsed.pathname}?${search}` : parsed.pathname;
	}
}
